import React, { useEffect, useMemo } from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { POIS, CITY_CENTER, areaCoords } from '../lib/geo';

const projectIcon = L.divIcon({
  className: '',
  html: '<div style="width:26px;height:26px;background:#C1440E;border:3px solid #fff;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 8px rgba(0,0,0,.45)"></div>',
  iconSize: [26, 26], iconAnchor: [13, 26], popupAnchor: [0, -26],
});
const poiIcon = L.divIcon({
  className: '',
  html: '<div style="width:13px;height:13px;background:#14532d;border:2px solid #fff;border-radius:50%;box-shadow:0 1px 4px rgba(0,0,0,.4)"></div>',
  iconSize: [13, 13], iconAnchor: [7, 7], popupAnchor: [0, -8],
});

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points || !points.length) return;
    if (points.length === 1) { map.setView(points[0], 13); return; }
    map.fitBounds(points, { padding: [45, 45], maxZoom: 13 });
  }, [points, map]);
  return null;
}

const ProjectMap = ({ project }) => {
  const data = useMemo(() => {
    const lat = Number(project.lat);
    const lng = Number(project.lng);
    const hasExact = Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0);
    const ac = areaCoords(project.area);
    const city = (ac && ac.city) || 'Dubai';
    const center = hasExact ? { lat, lng } : (ac || CITY_CENTER[city]);
    const pois = POIS.filter((p) => p.city === city);
    const projectPoint = [center.lat, center.lng];
    const points = [projectPoint, ...pois.map((p) => [p.lat, p.lng])];
    return { city, pois, projectPoint, points };
  }, [project.lat, project.lng, project.area]);

  return (
    <div className="relative z-0 rounded-2xl overflow-hidden border border-gobra-sand" style={{ height: 420 }} data-testid="project-map">
      <MapContainer center={data.projectPoint} zoom={12} scrollWheelZoom={false} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; Esri, HERE, Garmin, OpenStreetMap contributors'
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
        />
        <FitBounds points={data.points} />
        <Marker position={data.projectPoint} icon={projectIcon}>
          <Popup>
            <strong>{project.name}</strong>
            {project.area ? <><br />{project.area}</> : null}
          </Popup>
        </Marker>
        {data.pois.map((p) => (
          <Marker key={p.name} position={[p.lat, p.lng]} icon={poiIcon}>
            <Popup>{p.name}</Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default ProjectMap;
